import { MDBCol, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow } from 'mdb-react-ui-kit'
import React from 'react'
import { checkediconblack } from '../assets/images/images';
import { useNavigate } from 'react-router';

const ContactUs = () => {

    const navigate = useNavigate();

    const handleDemoClick = () => {
        navigate('/bookademo');
    };
    const handlePricingClick = () => {
        navigate('/commercials');
    };

    return (
        <>

            <MDBContainer className="lp_revenue p-0">
                <MDBCol size='12' className='text-center my-5'>
                    <h2 className='mb-3'><span className='lp_revenue_header'>Connect </span> Instantly</h2>
                    <p className='text-center'>
                        Is your questions answered? Contact us now!
                    </p>
                </MDBCol>
                <MDBCol size='12'>
                    <MDBRow>
                        <MDBCol sm='12' md='6' className='d-flex flex-column justify-content-center'>
                            <div class="card lp_getintouch">
                                <div class="card-body p-4">
                                    <h3 class="card-title mb-4">Your Digital Fitness Partner</h3>
                                    <p class="card-text">Take control of your gym, yoga studio, or fitness center with an all-in-one platform designed to streamline operations and enhance member satisfaction.
                                    </p>
                                    <MDBListGroup>
                                        <MDBListGroupItem noBorders className='lp_custom-list' >
                                            <img
                                                src={checkediconblack}
                                                className='mr-3'
                                                alt=""
                                            />
                                            Manage member profiles, assign personalized plans, handle billing, and offer add-ons. Coordinate classes with advance booking, timely reminders, and integrated payments.

                                        </MDBListGroupItem>
                                        <MDBListGroupItem noBorders className='lp_custom-list' >
                                            <img
                                                src={checkediconblack}
                                                className='mr-3'
                                                alt=""
                                            />

                                            Track attendance and check-ins with detailed reports. Set role-based staff access for streamlined internal operations.

                                        </MDBListGroupItem>
                                        <MDBListGroupItem noBorders className='lp_custom-list' >
                                            <img
                                                src={checkediconblack}
                                                className='mr-3'
                                                alt=""
                                            />

                                            Keep members informed and engaged through WhatsApp updates, alerts, and direct support—all from one centralized system.

                                        </MDBListGroupItem>


                                    </MDBListGroup>
                                </div>
                            </div>
                        </MDBCol>

                        <MDBCol sm='12' md='6'>
                            <MDBRow>
                                <MDBCol size='12'>
                                    <div class="card lp_getintouch mb-3">
                                        <div class="card-body p-4">
                                            <h4 class="card-title mb-4" >Experience the Difference — Book A Demo Today
                                            </h4>
                                            <p class="card-text">Discover how EasyMembr platform can streamline your studio operations and enhance member satisfaction.
                                            </p>
                                            <div className='mt-4 mb-2'>
                                                <button className='me-3 lp_btn lp_fillbtn' color='primary' onClick={handlePricingClick}>
                                                    Get Started Now
                                                </button>
                                                <button outline className='lp_btn lp_outlinbtn' onClick={handleDemoClick}>
                                                    Book A Demo
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </MDBCol>
                                <MDBCol size='12'>
                                    <div class="card">
                                        <div class="card-body p-4">
                                            <MDBListGroup>
                                                <MDBListGroupItem noBorders className='lp_custom-list-getin d-flex align-items-center' >
                                                    <i class="fas fa-phone-alt"></i>
                                                    <div>
                                                        <h4> Call us</h4>
                                                        <span>Speak to EasyMembr expert</span> <br /> <span>+91 80192 96262</span>
                                                    </div>
                                                </MDBListGroupItem>
                                                <MDBListGroupItem noBorders className='lp_custom-list-getin d-flex align-items-center' >
                                                    <i class="far fa-envelope"></i>
                                                    <div>
                                                        <h4> Email us</h4>
                                                        <span>Connect with EasyMembr dedicated support team</span> <br />

                                                        <p className='connect-link'> <a className='p-0 fs-6' href='mailto:contact@easymembr.com'>contact@easymembr.com</a></p>
                                                    </div>
                                                </MDBListGroupItem>


                                            </MDBListGroup>
                                        </div>
                                    </div>
                                </MDBCol>
                            </MDBRow>

                        </MDBCol>



                    </MDBRow>
                </MDBCol>

            </MDBContainer>

        </>
    )
}

export default ContactUs
